import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_improvement_form = _resolveComponent("improvement-form")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_modal, { ref: "modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_improvement_form, {
            "form-type": _ctx.formType,
            "object-id": _ctx.objectId
          }, null, 8, ["form-type", "object-id"])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}